import script from "./BarraSuperior.vue?vue&type=script&setup=true&lang=js"
export * from "./BarraSuperior.vue?vue&type=script&setup=true&lang=js"

import "./BarraSuperior.vue?vue&type=style&index=0&id=8d591220&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d591220"]])

export default __exports__